// extracted by mini-css-extract-plugin
export default {"edgeLabel":"edgeLabel-index-AufBE"};